<template>
<v-text-field
    :label=label
    :value="value_label"
    disabled
    autocomplete="off"
    :hide-details="hide_details"
    :hint="hint"
    :persistent-hint="!!hint"
>

    <span
        slot="append-outer"
    >
         <m-edit-menu
            v-if="!read_only"
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
         />

       <m-edit-select-enum-dialog
            :label="coalesce_dialog_title"
            :enum_name="enum_name"
            :allow_any_enum_value="allow_any_enum_value"
            :option_descriptions="option_descriptions"
            :filter_options="filter_options"
            ref="edit-dialog"
            v-on:ok="setValue($event)"
       />

    </span>


</v-text-field>
</template>

<script>
const _ = require('lodash');

export default {
    props: {

        label: {
            type: String,
            default: function () { return ''; }
        },

        dialog_title: {
            type: String,
            default: function () { return null; }
        },

        value: {
            type: String,
            default: function() { return 'any_enum_value'; }
        },

        enum_name: {
            type: String,
            default: function() { return 'integration_name'; }
        },

        allow_any_enum_value: {
            type: Boolean,
            default: function() { return false; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },

        option_descriptions: {
            type: Object,
            default: function() { return null; }
        },

        filter_options: {
            type: Array,
            default: function() { return null; }
        },

        hint: {
            type: String,
            default: null
        },

        hide_details: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: 
    {
        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'edit' )
            {
                this.onEdit();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
            this.$refs['edit-dialog'].showDialog(this.value);
        },

        setValue(new_value)
        {
            this.$emit('input',new_value);
        },
    },

    computed: {
        possible_values() 
        {
            let ret = _.cloneDeep(this.$rc.enumChoices(this.enum_name));
            
            if ( !this.allow_any_enum_value )
            {
                ret.shift(); // remove the first value...
            }

            return ret;
        },

        value_label()
        {
            if (this.value == null || this.value === undefined) {
                return 'Click to select...';
            }
            return this.$rc.pretty(this.value, 'enum_'+this.enum_name);
        },

        coalesce_dialog_title()
        {
            if ( this.dialog_title != null && this.dialog_title.trim().length > 0 )
                return this.dialog_title;

            return this.label;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>